import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { User } from '../model/user.model';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export type UserState<T extends User> = EntityState<T>;

@Injectable({ providedIn: 'root' })
@StoreConfig({
  name: 'users',
  idKey: 'lngContactID',
  resettable: true,
})
export class UserStore<T extends User> extends EntityStore<UserState<T>> {
  constructor() {
    super();
  }
}
